/* OMS — Events list (Sheets JSON)
   - Filters out past events based on Europe/Madrid time
   - Filters: genre (single dropdown), artist_size, city
   - Supports optional event.image (URL)
   - Caching with TTL in localStorage
*/

(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function safeJSON(v) { try { return JSON.parse(v); } catch (e) { return null; } }
  function normalizeStr(v) { return String(v || '').trim(); }
  function normalizeLower(v) { return normalizeStr(v).toLowerCase(); }

  function uniq(arr) {
    var out = [];
    arr.forEach(function (x) {
      if (x == null) return;
      var s = String(x).trim();
      if (!s) return;
      if (out.indexOf(s) === -1) out.push(s);
    });
    return out;
  }

  // --- Random-looking (but stable) color per tag value ---
  function hashString(str) {
    str = String(str || '');
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h) + str.charCodeAt(i);
      h |= 0; // 32-bit
    }
    return Math.abs(h);
  }

  function tagColors(tagValue) {
    var t = String(tagValue || '').trim().toLowerCase();
    if (!t) return { bg: 'hsl(0 0% 90%)', fg: '#000' };

    var h = hashString(t);
    var hue = h % 360;           // 0–359
    var sat = 55 + (h % 36);     // 55–90
    var light = 35 + (h % 36);   // 35–70

    var bg = 'hsl(' + hue + ' ' + sat + '% ' + light + '%)';
    var fg = (light < 55) ? '#fff' : '#111';

    return { bg: bg, fg: fg };
  }

  // Build a Date in Europe/Madrid using Intl formatToParts
  function makeMadridDate(dateISO, timeHHMM) {
    if (!dateISO) return null;

    var time = timeHHMM && /^\d{2}:\d{2}$/.test(timeHHMM) ? timeHHMM : '00:00';
    var parts = dateISO.split('-');
    if (parts.length !== 3) return null;

    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);

    var t = time.split(':');
    var hh = parseInt(t[0], 10);
    var mm = parseInt(t[1], 10);

    // naive UTC timestamp
    var naiveUTC = Date.UTC(y, m - 1, d, hh, mm, 0);

    var tz = 'Europe/Madrid';
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });

    var parts2 = dtf.formatToParts(new Date(naiveUTC));
    var map = {};
    parts2.forEach(function (p) { map[p.type] = p.value; });

    var madridAsUTC = Date.UTC(
      parseInt(map.year, 10),
      parseInt(map.month, 10) - 1,
      parseInt(map.day, 10),
      parseInt(map.hour, 10),
      parseInt(map.minute, 10),
      parseInt(map.second, 10)
    );

    var offset = madridAsUTC - naiveUTC;
    return new Date(naiveUTC - offset);
  }

  function readCache(key) {
    var raw = localStorage.getItem(key);
    var parsed = safeJSON(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  }

  function writeCache(key, payload) {
    try { localStorage.setItem(key, JSON.stringify(payload)); } catch (e) {}
  }

  function clearEl(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function initOne(root) {
    var sectionId = root.getAttribute('data-section-id') || '';
    var endpoint = root.getAttribute('data-endpoint') || '';
    var maxEvents = parseInt(root.getAttribute('data-max') || '0', 10);
    var showFilters = root.getAttribute('data-show-filters') === 'true' || root.getAttribute('data-show-filters') === '1';
    var defaultArtist = root.getAttribute('data-default-artist-size') || '__all__';
    var defaultCity = normalizeStr(root.getAttribute('data-default-city') || '');
    var defaultGenre = root.getAttribute('data-default-genre') || '__all__'; // optional
    var cacheTTL = parseInt(root.getAttribute('data-cache-ttl-ms') || '60000', 10);
    if (!cacheTTL || cacheTTL < 0) cacheTTL = 60000;

    var grid = qs(root, '[data-oms-events-grid]');
    var statusEl = qs(root, '[data-oms-events-status]');
    var emptyEl = qs(root, '[data-oms-events-empty]');
    var errEl = qs(root, '[data-oms-events-error]');
    var template = qs(root, 'template[data-oms-events-template]');

    var genreSel = qs(root, '[data-oms-events-genre]');
    var sizeSel = qs(root, '[data-oms-events-artist-size]');
    var citySel = qs(root, '[data-oms-events-city]');
    var resetBtn = qs(root, '[data-oms-events-reset]');
    var toggleBtn = qs(root, '[data-oms-events-toggle]');
    var filtersPanel = qs(root, '[data-oms-events-filters-panel]');

    var cacheKey = 'oms_events_' + (endpoint || 'noep') + '_' + sectionId;

    var state = {
      all: [],
      filtered: [],
      filters: {
        genre: defaultGenre || '__all__',
        artist_size: defaultArtist || '__all__',
        city: defaultCity ? defaultCity : '__all__'
      }
    };

    function setStatus(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
    }

    function showError() {
      setHidden(errEl, false);
      setHidden(emptyEl, true);
    }

    function hideError() { setHidden(errEl, true); }

    function showEmpty() {
      setHidden(emptyEl, false);
      setHidden(errEl, true);
    }

    function hideEmpty() { setHidden(emptyEl, true); }

    function normalizeGenres(value) {
      if (!value) return [];
      var s = normalizeStr(value);
      if (!s) return [];
      return s.split(',').map(function (x) { return normalizeLower(x); }).filter(Boolean);
    }

    function parseEvent(raw) {
      var ev = {
        id: normalizeStr(raw && raw.id),
        title: normalizeStr(raw && raw.title),
        date: normalizeStr(raw && raw.date),
        time: normalizeStr(raw && raw.time),
        venue: normalizeStr(raw && raw.venue),
        address: normalizeStr(raw && raw.address),
        city: normalizeStr(raw && raw.city),
        genre: Array.isArray(raw && raw.genre) ? raw.genre.map(normalizeLower).filter(Boolean) : normalizeGenres(raw && raw.genre),
        artist_size: normalizeLower(raw && raw.artist_size),
        url: normalizeStr(raw && raw.url),
        image: normalizeStr(raw && raw.image)
      };
      if (!ev.id) ev.id = 'evt_' + Math.random().toString(36).slice(2);
      return ev;
    }

    function isPast(ev) {
      var dt = makeMadridDate(ev.date, ev.time);
      if (!dt) return true;
      return dt.getTime() < Date.now();
    }

    function sortSoonest(a, b) {
      var da = makeMadridDate(a.date, a.time) || new Date(8640000000000000);
      var db = makeMadridDate(b.date, b.time) || new Date(8640000000000000);
      return da.getTime() - db.getTime();
    }

    function populateFilterOptions(events) {
      if (!showFilters) return;

      var allGenres = [];
      var allCities = [];

      events.forEach(function (ev) {
        (ev.genre || []).forEach(function (g) { if (g) allGenres.push(g); });
        if (ev.city) allCities.push(ev.city);
      });

      allGenres = uniq(allGenres).sort();
      allCities = uniq(allCities).sort(function (a, b) { return a.localeCompare(b); });

      if (genreSel) {
        while (genreSel.options.length > 1) genreSel.remove(1);
        allGenres.forEach(function (g) {
          var opt = document.createElement('option');
          opt.value = g;
          opt.textContent = g;
          genreSel.appendChild(opt);
        });

        // Apply default/previous selection safely
        var desiredGenre = state.filters.genre || '__all__';
        var found = false;
        for (var gi = 0; gi < genreSel.options.length; gi++) {
          if (genreSel.options[gi].value === desiredGenre) { found = true; break; }
        }
        genreSel.value = found ? desiredGenre : '__all__';
        state.filters.genre = genreSel.value || '__all__';
      }

      if (citySel) {
        while (citySel.options.length > 1) citySel.remove(1);
        allCities.forEach(function (c) {
          var opt2 = document.createElement('option');
          opt2.value = c;
          opt2.textContent = c;
          citySel.appendChild(opt2);
        });

        if (state.filters.city && state.filters.city !== '__all__') {
          var foundCity = false;
          for (var ci = 0; ci < citySel.options.length; ci++) {
            if (citySel.options[ci].value === state.filters.city) { foundCity = true; break; }
          }
          citySel.value = foundCity ? state.filters.city : '__all__';
          state.filters.city = citySel.value || '__all__';
        } else {
          citySel.value = '__all__';
        }
      }

      if (sizeSel) sizeSel.value = state.filters.artist_size || '__all__';
    }

    function readFiltersFromUI() {
      if (!showFilters) return;
      if (genreSel) state.filters.genre = genreSel.value || '__all__';
      if (sizeSel) state.filters.artist_size = sizeSel.value || '__all__';
      if (citySel) state.filters.city = citySel.value || '__all__';
    }

    function applyFilters() {
      var genre = state.filters.genre || '__all__';
      var size = state.filters.artist_size || '__all__';
      var city = state.filters.city || '__all__';

      var filtered = state.all.slice();

      // genre filter (single)
      if (genre !== '__all__') {
        filtered = filtered.filter(function (ev) {
          var evGenres = ev.genre || [];
          return evGenres.indexOf(genre) !== -1;
        });
      }

      // artist size filter
      if (size !== '__all__') {
        filtered = filtered.filter(function (ev) { return (ev.artist_size || '') === size; });
      }

      // city filter
      if (city !== '__all__') {
        filtered = filtered.filter(function (ev) { return (ev.city || '') === city; });
      }

      filtered.sort(sortSoonest);

      if (maxEvents && maxEvents > 0) filtered = filtered.slice(0, maxEvents);

      state.filtered = filtered;
    }

    function formatDateDisplay(dateISO) {
      if (!dateISO) return '';
      try {
        var d = makeMadridDate(dateISO, '00:00');
        if (!d) return dateISO;
        return new Intl.DateTimeFormat('es-ES', {
          timeZone: 'Europe/Madrid',
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        }).format(d);
      } catch (e) {
        return dateISO;
      }
    }

    function render() {
      hideError();
      clearEl(grid);

      if (!state.filtered || state.filtered.length === 0) {
        showEmpty();
        setStatus('0 upcoming events');
        return;
      }

      hideEmpty();
      setStatus(state.filtered.length + ' upcoming event' + (state.filtered.length === 1 ? '' : 's'));

      state.filtered.forEach(function (ev) {
        var frag = template.content.cloneNode(true);

        var titleEl = frag.querySelector('[data-evt-title]');
        var dateEl = frag.querySelector('[data-evt-date]');
        var timeEl = frag.querySelector('[data-evt-time]');
        var venueEl = frag.querySelector('[data-evt-venue]');
        var addrEl = frag.querySelector('[data-evt-address]');
        var cityEl = frag.querySelector('[data-evt-city]');
        var tagsEl = frag.querySelector('[data-evt-tags]');
        var urlEl = frag.querySelector('[data-evt-url]');
        var mediaEl = frag.querySelector('[data-evt-media]');
        var imgEl = frag.querySelector('[data-evt-img]');

        if (titleEl) titleEl.textContent = ev.title || '';
        if (dateEl) dateEl.textContent = formatDateDisplay(ev.date);
        if (timeEl) timeEl.textContent = ev.time || '';
        if (venueEl) venueEl.textContent = ev.venue || '';
        if (addrEl) addrEl.textContent = ev.address || '';

        if (cityEl) {
          cityEl.textContent = ev.city ? ('• ' + ev.city) : '';
          if (!ev.city) cityEl.style.display = 'none';
        }

        if (tagsEl) {
          var tags = [];
          (ev.genre || []).forEach(function (g) { if (g) tags.push(g); });
          if (ev.artist_size) tags.push(ev.artist_size);

          tags = uniq(tags);

          tags.forEach(function (t) {
            var span = document.createElement('span');
            span.className = 'oms-events__tag';
            var c = tagColors(t);
            span.style.background = c.bg;
            span.style.color = c.fg;
            span.style.borderColor = 'transparent';
            span.textContent = t;
            tagsEl.appendChild(span);
          });
        }

        if (urlEl) {
          if (ev.url) {
            urlEl.href = ev.url;
            urlEl.style.display = '';
          } else {
            urlEl.removeAttribute('href');
            urlEl.style.display = 'none';
          }
        }

        if (mediaEl && imgEl) {
          if (ev.image) {
            imgEl.src = ev.image;
            imgEl.alt = ev.title ? ev.title : 'Event image';
            mediaEl.hidden = false;
          } else {
            mediaEl.hidden = true;
          }
        }

        grid.appendChild(frag);
      });
    }

    function hydrateFromData(data) {
      var arr = Array.isArray(data) ? data : [];
      var parsed = arr.map(parseEvent);

      parsed = parsed.filter(function (ev) { return !isPast(ev); });
      parsed.sort(sortSoonest);

      state.all = parsed;

      populateFilterOptions(state.all);
      applyFilters();
      render();
    }

    function fetchEvents(opts) {
      opts = opts || {};
      var bypassCache = !!opts.bypassCache;

      if (!endpoint) {
        showError();
        setStatus('');
        return Promise.resolve([]);
      }

      var now = Date.now();

      if (!bypassCache) {
        var cached = readCache(cacheKey);
        if (cached && cached.exp && cached.data && now < cached.exp) {
          return Promise.resolve(cached.data);
        }
      }

      return fetch(endpoint, { method: 'GET', credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (json) {
          writeCache(cacheKey, { exp: now + cacheTTL, data: json });
          return json;
        });
    }

    function bindUI() {
      if (!showFilters) return;

      // Toggle filters panel
      if (toggleBtn && filtersPanel) {
        toggleBtn.addEventListener('click', function () {
          var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
          toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (isOpen) filtersPanel.setAttribute('hidden', '');
          else filtersPanel.removeAttribute('hidden');
        });
      }

      function onChange() {
        readFiltersFromUI();
        applyFilters();
        render();
      }

      if (genreSel) genreSel.addEventListener('change', onChange);
      if (sizeSel) sizeSel.addEventListener('change', onChange);
      if (citySel) citySel.addEventListener('change', onChange);

      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          state.filters.genre = '__all__';
          state.filters.artist_size = defaultArtist || '__all__';
          state.filters.city = defaultCity ? defaultCity : '__all__';

          if (genreSel) genreSel.value = '__all__';
          if (sizeSel) sizeSel.value = state.filters.artist_size;
          if (citySel) citySel.value = state.filters.city;

          // Optional: open panel on reset so it's obvious it changed
          if (toggleBtn && filtersPanel) {
            toggleBtn.setAttribute('aria-expanded', 'true');
            filtersPanel.removeAttribute('hidden');
          }

          applyFilters();
          render();
        });
      }
    }

    function init() {
      bindUI();
      setStatus('Loading…');

      fetchEvents()
        .then(function (json) { hydrateFromData(json); })
        .catch(function () {
          clearEl(grid);
          showError();
          hideEmpty();
          setStatus('');
        });

      // Auto-refresh every minute (bypass cache)
      setInterval(function () {
        if (!document.body.contains(root)) return;
        fetchEvents({ bypassCache: true })
          .then(function (json) { hydrateFromData(json); })
          .catch(function () { /* ignore */ });
      }, 60 * 1000);
    }

    init();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-oms-events]');
    if (!roots || !roots.length) return;
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();